import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Legals from "@/views/Legals.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/legals",
    name: "legals",
    component: Legals,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
